var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack547({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,9.6v-1h4v1Zm0,1.73v-1h4v1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack547);
export default __webpack_public_path__ + "static/media/Symbolpack_5_47.e8a3d6b4078057092977dad52837553d.svg";
export { ForwardRef as ReactComponent };